import { MutationKeyConfig, QueryKeyConfig } from './api-helper';

export const gridApiKeyStore = {
  saveGridLayOut: (): MutationKeyConfig => ({
    mutationKey: [`SAVE_GRID_LAYOUT`],
    route: `/User/SaveUserGridLayout`,
    action: 'POST',
    disableSnackbar: true,
  }),
  getGridLayout: (pageName: string, gridName: string): QueryKeyConfig => ({
    queryKey: [`GET_GRID_LAYOUT`, pageName, gridName],
    route: `/User/GetUserGridLayout?pageName=${pageName}&gridName=${gridName}`,
  }),
};
